import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axiosAuth from "@/services/axiosAuth";
import { BOM_USERS_API } from "../apiRoutes";

interface UseGetBomUserByCommunityIdProps {
  id: string;
  communityId: string;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getBomUserByCommunityId = async (id: string, communityId: string) =>
  await axiosAuth.get(`${BOM_USERS_API}/community/${communityId}/user/${id}`);

const useGetBomUserByCommunityId = ({
  id,
  communityId,
  queryParams,
}: UseGetBomUserByCommunityIdProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["bomUser", id],
    queryFn: () => getBomUserByCommunityId(id, communityId),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
  });
};

export default useGetBomUserByCommunityId;
